<template>
  <!-- 开票历史记录 -->
  <div class="invoiceRecordPage" v-if="!showLoad">
    <div class="kpList">
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field v-model="fpData.num" readonly label="发票号：" input-align="right" class="ggInput" />
        <van-field
          v-model="fpData.numAmount"
          readonly
          label="发票金额（元）："
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
    </div>
    <p class="fgx" v-if="kpDataList.length!=0"></p>
    <div class="applyList">
      <h4 v-if="kpDataList.length!=0">开票申请</h4>
      <ul v-if="kpDataList.length!=0">
        <li v-for="item in kpDataList" :key="item.id">
          <div class="listMain">
            <p class="clearfix">
              所属合同：
              <em>{{item.contractName}}</em>
            </p>
            <p class="clearfix">
              发票类型：
              <em>{{item.typeName}}</em>
            </p>
            <p>
              申请开票金额（元）：
              <em>{{item.amount}}</em>
            </p>
            <p>
              累计到帐（元）：
              <em>{{amountTotal}}</em>
            </p>
            <p v-if="item.oppositeTallage!=''">
              对方税号：
              <em>{{item.oppositeTallage}}</em>
            </p>
            <p>
              对方单位名称：
              <em>{{item.oppositeCompany}}</em>
            </p>
            <p>
              开票原因：
              <em>{{item.reason =='' ? '无':item.reason }}</em>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="btnBox denyBtn clearfix" v-if="amountTotal=='0' && voidType=='true'">
      <van-button type="info" @click="verifyPage">开票作废</van-button>
    </div>
    <!-- 开票作废 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <div class="resonBox">
        <van-cell-group class="baseNone beizhu">
          <p>作废原因：</p>
          <van-field
            v-model="abolishData.reason"
            rows="1"
            autosize
            input-align="right"
            :required="editType"
            type="textarea"
            :placeholder="editType?'请输入...  ':''"
            :readonly="!editType"
            class="zfyy"
          />
        </van-cell-group>
        <van-button type="info" class="zfBtn" @click="checkZf">作废</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
// import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
import { dateFormat } from "@/utils/common";
export default {
  name: "invoiceManage",
  data() {
    return {
      commonId: "", //用户申请Id
      commonType: "",
      voidType: "", //作废风格
      kpDataList: [],
      fpData: {
        num: "", //发票号
        numAmount: "", //发票金额
      },
      abolishData: {
        invalidType: "internal",
        makeInvoiceId: "",
        reason: "",
      },
      amountTotal: "", //到账累计金额
      btnShowStyle: false,
      verifyPageType: false, //作废原因弹框
      editType: true, //是否可编辑
      clientType: getDeviceType(),
    };
  },
  mounted() {
    window.getKpIds = this.getKpIds;
    this.voidType = this.$route.query.voidType; //作废Type
    this.commonId = this.$route.query.commonId; //开票Id
    this.$set(this.abolishData, "makeInvoiceId", this.commonId);
    this.setShowLoad(false);
    this.initPage();
  },

  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      if (this.clientType == "android") {
        window.android.getInfo(107);
      } else {
        window.webkit.messageHandlers.getKpIds.postMessage(null);
      }
      this.getmakeInvoicelist(); //发票号
    },
    getmakeInvoicelist() {
      let _this = this;
      _this.$api.finance.invoice
        .makeInvoicelist({ invoiceId: _this.commonId })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.fpData = res.data[0];
            _this.amountTotal = res.data[0].amountTotal; //累计到账金额
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getKpIds(data) {
      let ids = "";
      if (this.clientType == "android") {
        ids = data;
      } else {
        ids = JSON.parse(data);
      }
      this.getListByInvoiceId(ids);
    },
    getListByInvoiceId(ids) {
      let _this = this;
      _this.$api.finance.invoice
        .getListByInvoiceId(ids)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.kpDataList = res.data;
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    checkZf() {
      if (this.abolishData.reason == "") {
        this.$toast("作废原因不能为空！");
      } else {
        this.$dialog
          .confirm({
            title: "提示",
            message: "是否确认作废该发票",
          })
          .then(() => {
            this.zfInvoice();
          })
          .catch(() => {
            // on cancel取消作废发票
          });
      }
    },
    zfInvoice() {
      let _this = this;
      _this.$api.finance.invoice
        .addAbolishInvoice(_this.abolishData)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let text = "操作成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.invoiceRecordPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .fgx {
    width: 100%;
    height: 8px;
    background-color: #f6f6f6;
  }
  .baseNone.dwBox {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #666;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .applyList {
    padding-top: 10px;
    h4 {
      position: relative;
      border-bottom: 1px solid #e0e0e0;
      line-height: 25px;
      padding: 0 25px;
      padding-right: 0;
      padding-bottom: 5px;
      font-weight: 700;
      color: #2581d6;
      font-size: 15px;
      z-index: 10;
      background-color: #fff;
    }
    h4:before {
      content: "";
      position: absolute;
      width: 5px;
      background: #2581d6;
      top: 0;
      left: 15px;
      bottom: 5px;
    }
    li {
      width: 100%;
      margin: 10px 0;
      padding: 0 16px 8px 16px;
      border-bottom: 1px solid #f6f6f6;
      .listMain {
        p {
          font-size: 14px;
          color: #333;
          margin: 5px 0;
          border-bottom: 1px solid #f6f6f6;
          padding: 7px 10px 7px 0;
          em {
            float: right;
            color: #666;
            font-weight: normal;
          }
        }
      }
    }
    li:last-child {
      border: 0 none;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  .verifyPage {
    height: 70%;
    padding-top: 45px;
    .baseNone.beizhu::after {
      content: none;
    }
    .resonBox {
      width: 100%;
      padding: 0 5px;
      min-height: 100%;
      overflow-y: scroll;
      p {
        width: 100%;
        padding: 0 16px;
        font-size: 15px;
      }
      .zfyy {
        .van-cell__value {
          width: 100%;
          min-height: 120px;
          border: 1px solid #f6f6f6;
          padding: 5px 3px;
          textarea {
            text-align: left;
            text-indent: 2em;
          }
        }
      }
      .zfyy.van-cell--required::before {
        top: -20px;
        left: 5px;
      }
      .zfBtn {
        position: absolute;
        bottom: 5px;
        width: 50%;
        left: 50%;
        margin-left: -25%;
        border-radius: 12px;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        span {
          line-height: 45px;
        }
      }
    }
  }
}
</style>